<script lang="ts">
  import { formatDate } from "$app/utils"
  import { appStore } from "$app/store.svelte"

  let props = $props()
  let {
    progress,
    clazz
  }: {
    progress: ProgressType
    clazz: string
  } = props

  const user: UserType | undefined = appStore.users.find(
    (u) => progress.user_id === u.id
  )
</script>

{#if user}
  <div class={`border-l-4 border-progress ${clazz}`}>
    <div class="border-t border-gray-200 py-3 px-4 flex">
      <div class="flex-shrink pr-3 sm:pr-4">
        <img
          src={user.avatar_thumb_url}
          alt={user.name}
          class="rounded-full w-8 h-8 sm:w-12 sm:h-12"
        />
      </div>
      <div class="flex-1">
        <div class="flex items-center flex-wrap">
          <div class="font-semibold text-sm pr-2">{user.name}</div>
          <div class="text-xs">
            {formatDate(new Date(progress.created_at))}
          </div>
        </div>
        <div>{progress.progress_text}</div>
      </div>
    </div>
  </div>
{/if}
